import { IDaDataSuggestion, IDaDataSuggestionResponse } from '../dadata';

export enum EGender {
  Male = 'MALE',
  Female = 'FEMALE',
  Unknown = 'UNKNOWN',
}

export enum EPartsUpper {
  Patronymic = 'PATRONYMIC',
  Name = 'NAME',
  Surname = 'SURNAME',
}

export enum EPartsLower {
  Patronymic = 'patronymic',
  Name = 'name',
  Surname = 'surname',
}

export interface IFio {
  surname: string | null;
  name: string | null;
  patronymic: string | null;
  gender: EGender;
}

export type TFIOSuggestion = IDaDataSuggestion<IFio>;

export type TFIOSuggestions = IDaDataSuggestionResponse<IFio>;
